//Styling and Animation
import styled from "styled-components";
import { motion } from "framer-motion";
//Redux
import { useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import { smallImage } from '../util';
//Images
import playstation from "../img/playstation.svg";
import steam from "../img/steam.svg";
import xbox from "../img/xbox.svg";
import nintendo from "../img/nintendo.svg";
import apple from "../img/apple.svg";
import gamepad from "../img/gamepad.svg";
//Star Images
import starEmpty from "../img/star-empty.png";
import starFull from "../img/star-full.png";

const GameDetail = ({ pathId }) => {
  //Data
  const { screen, game, isLoading } = useSelector((state) => state.detail);
  const history = useHistory();

  const exitDetailHandler = (e) => {
    const element = e.target;
    if (element.classList.contains("shadow")) {
      document.body.style.overflow = "auto";
      history.push("/");
    }

  }

  const getStars = () => {
    const stars = [];
    const rating = Math.floor(game.rating);
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars.push(<img alt="star" key={i} src={starFull}></img>);
      } else {
        stars.push(<img alt="star" key={i} src={starEmpty}></img>);
      }
    }
    return stars;
  };

  const getPlatformImages = (platform) => {
    switch (platform) {
      case "PlayStation 4":
        return playstation;
      case "Xbox One":
        return xbox;
      case "PC":
        return steam;
      case "Nintendo Switch":
        return nintendo;
      case "iOS":
        return apple;
      default:
        return gamepad;
    }
  };

  return (
    <>
      {!isLoading && (
        <CardShadow className="shadow" onClick={exitDetailHandler}>
          <Detail layoutId={pathId}>
            <Stats>
              <div className="rating">
                <motion.h3 layoutId={`title ${pathId}`} > {game.name}</motion.h3>
                <p>Rating: {game.rating}</p>
                {getStars()}
              </div>
              <Info>
                <h3>Platforms</h3>
                <Platforms>
                  {game.platforms?.map((data) => (
                    <img
                      alt={data.platform.name}
                      key={data.platform.id}
                      src={getPlatformImages(data.platform.name)}
                    ></img>
                  ))}
                </Platforms>
              </Info>
            </Stats>
            <Media>
              {game.background_image != null ? (
                <motion.img src={smallImage(game.background_image, 1280)} alt={game.background_image} layoutId={`image ${pathId}`} />)
                : (<p>No Cover Image </p>)}
            </Media>
            <Description>
              <p>{game.description_raw}</p>
            </Description>
            <div className="gallery">
              {screen.results?.map((screen) => (
                <img src={smallImage(screen.image, 1280)} key={screen.id} alt={screen.image} />
              ))}
            </div>
          </Detail>
        </CardShadow>)}
    </>
  );
};

const CardShadow = styled(motion.div)`
  width: 100%;
  min-height: 100vh;
  overflow-y: scroll;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index:5;
  &::-webkit-scrollbar {
    width: 0.5rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ff7676;
  }

  &::-webkit-scrollbar-track {
    background: white;
  }
`;

const Detail = styled(motion.div)`
  width: 80%;
  border-radius: 1rem;
  padding: 2rem 5rem;
  background: white;
  position: absolute;
  left: 10%;
  color: black;
  img {
    width: 100%;
  }

  @media (max-aspect-ratio: 1/1){
    padding: 1rem 1rem;
  }
`;

const Stats = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  img {
    width: 2rem;
    height: 2rem;
    display: inline;
  }

  @media (max-aspect-ratio: 1/1){
    align-items: flex;
    justify-content: flex-start;
  }

`;

const Info = styled(motion.div)`

  text-align: center;
  @media (max-aspect-ratio: 1/1){
        text-align:left;
  }
`;

const Platforms = styled(motion.div)`
  display: flex;
  justify-content: space-evenly;
  flex-wrap:wrap;
  img{
    margin-left: 3rem;
  }
  @media (max-aspect-ratio: 1/1){
    
    justify-content:flex-start;

    img{
      margin-left:0rem;
      margin-right:2rem;
      margin-top:1rem;
    }

  }
`;

const Media = styled(motion.div)`

  margin-top: 5rem;

  img{
    width: 100%;
    object-fit: cover;
  }

  @media (max-aspect-ratio: 1/1){
        margin-top: 2rem;
  }
`;

const Description = styled(motion.div)`
  margin : 5rem 0rem;
  text-align: justify;
  @media (max-aspect-ratio: 1/1){
        margin: 2rem 0rem;
  }
`;
export default GameDetail;
